import { BlankCalendarDay, DateObj } from '../types';

export default function getWeeks(dates: (BlankCalendarDay | DateObj)[]) {
  const weeksLength = Math.ceil(dates.length / 7);
  const weeks: (BlankCalendarDay | DateObj)[][] = [];
  for (let i = 0; i < weeksLength; i++) {
    weeks[i] = [];
    for (let x = 0; x < 7; x++) {
      weeks[i].push(dates[i * 7 + x]);
    }
  }
  return weeks;
}
